import React from "react";
export const CODInput = React.memo(({ label, name, type = "text", value = "", placeholder=undefined, onChange, disabled, required, ...rest }) => {
   
    value = type === "date" ? value === "" ? new Date() : value : value;
    placeholder = placeholder || label; 
    return (
      <div className="CODform-group">
        <label>{label}{required && "*"}</label>
        <input
          type={type}
          name={name}
          placeholder={placeholder || ""} 
          value={value}
          onChange={onChange}
          disabled={disabled}
          required={required}
          {...rest}
        />
      </div>
    );
  });